import { render } from "./update-example-company.vue?vue&type=template&id=1b607c80&scoped=true"
import script from "./update-example-company.vue?vue&type=script&lang=js"
export * from "./update-example-company.vue?vue&type=script&lang=js"

import "./update-example-company.vue?vue&type=style&index=0&id=1b607c80&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b607c80"],['__file',"src/components/applications/admin/update/update-example-company.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b607c80"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b607c80', __exports__)) {
    api.reload('1b607c80', __exports__)
  }
  
  module.hot.accept("./update-example-company.vue?vue&type=template&id=1b607c80&scoped=true", () => {
    api.rerender('1b607c80', render)
  })

}


export default __exports__